import React from 'react'
import { authRoles } from '../../auth/authRoles'

const HotelOwnerRoute = [

    {
        path: '/owner_hotels',
        component: React.lazy(() => import('./Dashboard/Hotels')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/booking_list',
        component: React.lazy(() => import('./Booking/All')),
        auth: authRoles.booking,
    },
    {
        path: '/booking_signle_view/:id',
        component: React.lazy(() => import('./Booking/Tabs/Single_View')),
        auth: authRoles.booking,
    },
    {
        path: '/booking_cancel_signle_view/:id',
        component: React.lazy(() => import('./Booking/Tabs/Single_cancel_View')),
        auth: authRoles.hotel_owner,
    },
    {
        path: '/calender',
        component: React.lazy(() => import('./Calender/Celender')),
        auth: authRoles.hotel_owner,
    },


     // discounts
    {
        path: '/discountsSetup',
        component: React.lazy(() => import('./Discount/Discount')),
        auth: authRoles.hotel_owner,
    },
    
  
]

export default HotelOwnerRoute
